export default __webpack_public_path__ + "static/media/information--rest-area--g1.23aa47b9.png";